// removed by extract-text-webpack-plugin
module.exports = {"nice-select":"nice-select","icon":"icon","rotate":"rotate","picker-clear":"picker-clear","active":"active"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Form/Select.scss
// module id = 217
// module chunks = 0